import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { SimpleTextEditor } from 'components/inputs/simpleTextEditor';
import { CreateChancel, DateCalendarForm } from 'components';
import { eventActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, FindSuccessItem } from 'utils';

export const CreateEvent = ({ info, model, afterSuccess, handleClose }) => {
    const { watch, handleSubmit, control, reset } = useForm();
    const ACTION_TYPE = info ? 'EDIT_EVENT' : 'CREATE_EVENT';
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (info) {
            const params = {
                ...info,
            };
            params.reason = info?.reason || '';
            reset(params);
        } else {
            reset({});
        }
    }, [info]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            handleClose();
            afterSuccess();
        }
    }, [success]);

    const handleCreate = (data) => {
        const sandedData = {
            ...data,
            reason: data?.reason,
            ...model,
        };

        if (info?.id) {
            dispatch(eventActions.editEvent(info?.id, sandedData));
        } else {
            dispatch(eventActions.createEvent(sandedData));
        }
    };

    return (
        <div style={{ width: 600 }}>
            <p className="modal-header-title">{info ? 'Edit Event' : 'Add Event'}</p>
            <div className="modal-body-wrapper" style={{ marginBottom: 0 }}>
                <form onSubmit={handleSubmit(handleCreate)}>
                    <DateCalendarForm
                        label={'Event Date*'}
                        name={'eventDate'}
                        control={control}
                        type={'modalInput'}
                        rules={{ required: 'Event Date is required.' }}
                    />
                    <p className="text-editor-title">
                        Reason <span style={{ color: '#FE7070' }}>*</span>
                    </p>
                    <Controller
                        control={control}
                        name="reason"
                        defaultValue={''}
                        rules={{
                            validate: (value) => {
                                const strippedText = value.replace(/<[^>]*>/g, '').trim();
                                return strippedText.length > 0 || 'Reason is required.';
                            },
                        }}
                        render={({ field, fieldState: { error } }) => (
                            <SimpleTextEditor value={field.value} onChange={field.onChange} placeholder="Write Here..." error={error} />
                        )}
                    />

                    <CreateChancel
                        type="submit"
                        loader={!!loader.length}
                        create={info ? 'Save' : 'Add'}
                        chancel={'Cancel'}
                        onClose={handleClose}
                        buttonWidth="100%"
                        cancelRight={'24px'}
                    />
                </form>
            </div>
        </div>
    );
};
